<template>
	<div class="project-chart">
		<doughnut-chart class="chart-frame" :chart-data="chartData" :options="options"></doughnut-chart>
	</div>
</template>

<script>
	import DoughnutChart from '@/modules/charts/DoughnutChart';

	export default {
		name: 'SpendByProject',

		props: {
			invoices: { type: Array, required: false, default: () => [] },
			projects: { type: Array, required: false, default: () => [] },
		},

		components: { DoughnutChart },

		computed: {
			options() {
				return {
					showTooltips: true,
					responsive: true,
					maintainAspectRatio: false,
					cutoutPercentage: 66,
					legend: {
						position: 'bottom',
						labels: {
							boxWidth: 10,
							fontColor: '#867F77',
							padding: 16,
							usePointStyle: true,
						},
					},
					tooltips: {
						displayColors: false,
						backgroundColor: 'rgba(16, 17, 15, 0.92)',
						cornerRadius: 8,
						xPadding: 12,
						yPadding: 10,
						callbacks: {
							title: () => '',
							label: (tooltipItem, data) => {
								const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
								const amount = this.$formatters.dollars(
									value,
									true,
									true,
									this.$store.state.defaultCurrency
								);
								return `${data.labels[tooltipItem.index]}: ${amount}`;
							},
						},
					},
				};
			},

			chartData() {
				return {
					labels: this.labels,
					datasets: [
						{
							label: this.$t('invoices.project'),
							data: this.invoiced,
							backgroundColor: this.$store.state.chartColors,
							borderColor: this.$vuetify.theme.currentTheme.white,
							borderWidth: 3,
							hoverBorderWidth: 3,
						},
					],
				};
			},

			labels() {
				return this.invoiceByProject.map((project) => project.name);
			},

			invoiced() {
				return this.invoiceByProject.map((project) => project.amount);
			},

			invoiceByProject() {
				if (!this.invoices.length || !this.projects.length) {
					return [];
				}

				const projectMap = new Map();
				this.projects.forEach((project) =>
					projectMap.set(project.id, {
						id: project.id,
						name: project.name,
						amount: 0,
					})
				);

				this.invoices.forEach((invoice) => {
					(invoice.items || []).forEach((item) => {
						if (item.projectId && projectMap.has(item.projectId)) {
							projectMap.get(item.projectId).amount += item.subtotal;
						}
					});
				});

				return Array.from(projectMap.values())
					.filter((project) => project.amount > 0)
					.sort((projectA, projectB) => projectB.amount - projectA.amount);
			},
		},
	};
</script>

<style scoped lang="scss">
	.project-chart {
		height: 330px;
		padding: 18px 16px 12px;
	}

	.chart-frame {
		position: relative;
		height: 100%;
	}

	.project-chart ::v-deep canvas {
		width: 100% !important;
		height: 100% !important;
	}

	@media (max-width: 599px) {
		.project-chart {
			height: 310px;
			padding: 14px 10px 10px;
		}
	}
</style>
